import { Box, Button, Flex, Heading, Input } from "@chakra-ui/react";
import React from "react";
import { useState } from "react";
import { Navigate } from "react-router-dom";

const Register = () => {
  const [email, setEmail] = useState("");
  const [pass, setPassword] = useState("");
  const [name, setName] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = () => {
    const payload = {
      name,
      email,
      pass,
    };

    fetch("https://dull-tan-drill-gear.cyclic.app/users/register", {
      method: "POST",
      body: JSON.stringify(payload),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((res) => {
        setMessage(res.msg);
      })
      .catch((e) => console.log(e));
  };

  if (message === "User Registeration Sucessful") {
    alert(`${message},Please Click on Ok to Login`);
    return <Navigate to="/login" />;
  }
  if (message === "Email is already Registered") {
    alert(`${message},Please Click on Ok to Login`);
    return <Navigate to="/login" />;
  }
  return (
    <Box>
      <Heading as={"h5"} size="lg" textAlign={"center"} m={"50px"}>
        Registration Page
      </Heading>
      <Flex
        direction={"column"}
        gap={"20px"}
        w={"25%"}
        m={"auto"}
        padding={"30px"}
        borderRadius={"20px"}
        boxShadow={"rgba(0, 0, 0, 0.35) 0px 5px 15px"}
      >
        <Input
          type={"text"}
          placeholder={"Enter Name"}
          value={name}
          onChange={(e) => {
            setName(e.target.value);
          }}
        />
        <Input
          type={"text"}
          placeholder={"Enter Email"}
          value={email}
          onChange={(e) => {
            setEmail(e.target.value);
          }}
        />
        <Input
          type={"password"}
          placeholder={"Enter Password"}
          value={pass}
          onChange={(e) => {
            setPassword(e.target.value);
          }}
        />
        <Button onClick={handleSubmit} colorScheme="teal" variant={"outline"}>
          Register
        </Button>
      </Flex>
    </Box>
  );
};

export default Register;
